const localstorageConstants = {
  TOKEN: 'token',
  ORIGIN: 'origin',
  APP_INFO: 'newtail:appInfo',
  ACCOUNT_INFO: 'newtail:accountInfo',
  REDUX_PERSIST: 'persist:newtail',
  SUPER_ADMIN: 'vtexads:superAdmin'
}

export const LOCALSTORAGE_CHANGE_EVENT = 'newtail:localstorage-change'

const notifyLocalstorageChange = key =>
  document.dispatchEvent(
    new CustomEvent(LOCALSTORAGE_CHANGE_EVENT, { detail: { key } })
  )

export const getLocalstorage = key => localStorage.getItem(key)

/**
 * Lê e faz parse de um valor JSON. Valor corrompido é descartado em vez de
 * lançar, para não bloquear fluxos que dependem dessa leitura (ex.: login).
 */
export const getParsedLocalstorage = key => {
  const value = localStorage.getItem(key)

  if (!value) return null

  try {
    return JSON.parse(value)
  } catch {
    localStorage.removeItem(key)

    return null
  }
}

export const setLocalstorage = (key, value) => {
  localStorage.setItem(key, value)
  notifyLocalstorageChange(key)
}

export const removeLocalstorage = key => {
  localStorage.removeItem(key)
  notifyLocalstorageChange(key)
}

export default localstorageConstants
